export default __webpack_public_path__ + "static/media/applications_interface_security.c07b46bf.png";